var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudDataDatalab(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    id: "Layer_1",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "6.708 42 4.699 46 16.37 46 18.379 42 6.708 42"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45.382 4 29.618 4 26.618 10 42.382 10 45.382 4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "44 24.288 46 19.788 46 7.236 44 11.236 44 24.288"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 12,
    width: 12,
    x: 4,
    y: 48
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18 56.104 19 53.864 19 45.22 18 47.211 18 56.104"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59 56.104 60 53.864 60 45.22 59 47.211 59 56.104"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,24H25a2.966,2.966,0,0,0,1-.184V28H42V12H26v6.185A2.956,2.956,0,0,0,25.039,18l-1.069.089a.985.985,0,0,1-1.057-.77A2.945,2.945,0,0,0,19,15.187,1,1,0,0,1,17.73,14.6a3.982,3.982,0,0,0-7.658.708,1,1,0,0,1-1.2.8A3.9,3.9,0,0,0,8,16a4,4,0,0,0,0,8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.708 42 45.699 46 57.37 46 59.379 42 47.708 42"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 12,
    width: 12,
    x: 45,
    y: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,13.991a4,4,0,0,0-4-4l-1.113.093a3.945,3.945,0,0,0-5.221-2.848A5.03,5.03,0,0,0,49,5V17.991h8A4,4,0,0,0,61,13.991Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,44V42H35.858A4,4,0,0,0,33,39.142V29H31V39.142A4,4,0,0,0,28.142,42H20v2h8.142a3.981,3.981,0,0,0,7.716,0Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudDataDatalab);
export default __webpack_public_path__ + "static/media/cloudDataDatalab.13ba690db96f2552257f7f2e514973ca.svg";
export { ForwardRef as ReactComponent };